var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.11 218.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    transform: "translate(18.25 16.329) scale(.85047)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 137.58,
    r: 18.94,
    style: {
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 194.41,
    r: 18.94,
    style: {
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 80.75,
    r: 18.94,
    style: {
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 23.91,
    r: 18.94,
    style: {
      fill: "#e79933"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.61 195.3 19.5-43.8c18.6 12.3 45 20.7 69.3 20.7 24.6 0 34.2-6.9 34.2-17.1 0-33.3-119.4-9-119.4-87 0-37.5 30.6-68.1 93-68.1 27.3 0 55.5 6.3 76.2 18.3l-18.3 44.1c-20.1-10.8-39.9-16.2-58.2-16.2C134 46.2 125 54.6 125 65.1c0 32.1 119.1 8.1 119.1 85.5 0 36.6-30.6 67.8-93 67.8-34.49 0-68.69-9.3-88.49-23.1z",
    style: {
      fill: "gray"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/surveys.cce89381f503034f596385590b571b3a.svg";
export { ForwardRef as ReactComponent };